import { DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommPositionMovementQuickInfo extends Layout {
    panelQuickInfo: Panel;
    sourceMovement: DataSource;
    sourceStop: DataSource;
    tableStop: Table;
    textboxBillDistance: Textbox;
    textboxFreightCharge: Textbox;
    textboxMovementId: Textbox;
}
